import { render, staticRenderFns } from "./FavoriteAddress.vue?vue&type=template&id=3869c7ea&"
import script from "./FavoriteAddress.vue?vue&type=script&lang=js&"
export * from "./FavoriteAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports